import { render } from "./QualIssueSummary.vue?vue&type=template&id=a4452fbe&scoped=true"
import script from "./QualIssueSummary.vue?vue&type=script&lang=js"
export * from "./QualIssueSummary.vue?vue&type=script&lang=js"

import "./QualIssueSummary.vue?vue&type=style&index=0&id=a4452fbe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4452fbe"]])

export default __exports__